// src/services/expenseService.js
import { api } from './api';

function buildQuery(params) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) qs.append(k, v); });
  const s = qs.toString();
  return s ? '?' + s : '';
}

export const expenseService = {
  getExpenses: (status, category, dateFrom, dateTo) => {
    const qs = buildQuery({ status, category, date_from: dateFrom, date_to: dateTo });
    return api.get('/api/expenses/' + qs);
  },

  getExpense: (id) =>
    api.get('/api/expenses/' + id),

  submitExpense: (data) =>
    api.post('/api/expenses/', data),

  // Bug fix: edit an expense's own details while it's still Pending.
  updateExpense: (id, data) =>
    api.put('/api/expenses/' + id, data),

  updateStatus: (id, status, comments) =>
    api.put('/api/expenses/' + id + '/status', { status, comments }),

  getReceiptUrl: (id) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    return baseUrl + '/api/expenses/' + id + '/receipt';
  },

  // Authenticated Excel download (window.open can't send the auth header).
  exportExcel: async (status, category, dateFrom, dateTo) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const qs = buildQuery({ status, category, date_from: dateFrom, date_to: dateTo });
    const token = localStorage.getItem('access_token');

    const res = await fetch(baseUrl + '/api/expenses/export/excel' + qs, {
      headers: token ? { Authorization: 'Bearer ' + token } : {},
    });
    if (!res.ok) throw new Error('Failed to export expenses');

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'expense_report.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};